/* ==========================================================================
   NV — Motor de suscripción
   --------------------------------------------------------------------------
   Un solo motor para TODOS los formularios de correo de la web: el pop-up,
   el bloque bajo los packs y el del pie de página.

   Cada formulario vive dentro de una "unidad":

     <div data-nv-sub-unit [data-nv-sub-descuento]>
       <div data-nv-sub-view="form"> … {% render 'nv-form-suscripcion' %} … </div>
       <div data-nv-sub-view="done" hidden> … </div>
     </div>

   Solo las unidades con data-nv-sub-descuento activan el descuento de
   suscriptor. El pie de página NO lo lleva: allí uno se apunta a los avisos
   y nada más, y el texto lo dice.

   El envío, y por qué NO va por un iframe
   ---------------------------------------
   Hubo una versión que enviaba a un iframe oculto para no recargar. Parecía
   funcionar y no registraba a nadie: esta tienda tiene la protección
   anti-bots de Shopify activada, /contact devuelve 400 sin su token, y el
   desafío no puede resolverse dentro de un iframe de 0×0. Encima, una red de
   seguridad daba el envío por bueno a los 6 segundos, así que la web decía
   "¡Listo!" mientras la lista de clientes seguía vacía.

   Ahora se envía como se envía cualquier formulario de Shopify: la página
   navega y Shopify vuelve con ?customer_posted=true y el id del formulario en
   el fragmento. Quien confirma el registro es Shopify, no nosotros.

   Cada unidad conserva su id propio porque ese fragmento es lo que distingue
   cuál de los tres se envió.
   ========================================================================== */

(function () {
  'use strict';

  /* ---- Validación del correo -------------------------------------------
     No pretende adivinar si la dirección existe (eso solo lo demuestra el
     envío real). Filtra lo que sí es detectable: formato imposible, buzones
     de usar y tirar, y erratas de tecleo en los dominios más comunes. ---- */

  /* Formato: algo@algo.tld con TLD de 2 a 24 letras y sin puntos seguidos. */
  var RE = /^[^\s@.][^\s@]*@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*\.[a-z]{2,24}$/i;

  /* Buzones temporales: quien los usa no piensa recibir nada. */
  var DESECHABLES = ['mailinator.com','yopmail.com','tempmail.com','temp-mail.org','10minutemail.com',
    'guerrillamail.com','sharklasers.com','trashmail.com','getnada.com','maildrop.cc','fakeinbox.com',
    'throwawaymail.com','mailnesia.com','dispostable.com','spamgourmet.com','mytemp.email','emailondeck.com'];

  /* Erratas frecuentes → se sugiere la corrección en vez de rechazar a secas. */
  var ERRATAS = {
    'gmial.com':'gmail.com','gmai.com':'gmail.com','gmail.co':'gmail.com','gmail.con':'gmail.com',
    'gmaill.com':'gmail.com','gnail.com':'gmail.com','gmail.cm':'gmail.com','gmail.om':'gmail.com',
    'hotmial.com':'hotmail.com','hotmai.com':'hotmail.com','hotmail.co':'hotmail.com','hotmail.con':'hotmail.com',
    'hotmali.com':'hotmail.com','otmail.com':'hotmail.com',
    'outlok.com':'outlook.com','outlook.co':'outlook.com','outloo.com':'outlook.com',
    'yaho.com':'yahoo.com','yahoo.co':'yahoo.com','yahooo.com':'yahoo.com',
    'icloud.co':'icloud.com','hotmail.es.com':'hotmail.es'
  };

  /* Terminaciones admitidas: genéricas, Latinoamérica y Europa. */
  var TLDS = ['com','co','net','org','edu','gov','mil','int','info','biz','name','pro',
    'io','me','app','dev','online','store','shop','site','web','xyz','cloud','email','live','link',
    'es','mx','ar','cl','pe','br','ve','ec','bo','py','uy','cr','pa','do','gt','hn','ni','sv','cu','pr',
    'us','uk','ca','fr','de','it','pt','nl','be','ch','at','se','no','dk','fi','ie','pl','gr','ro','cz',
    'ru','cn','jp','kr','in','au','nz','za','il','tr'];

  /* Erratas típicas al teclear la terminación. */
  var ERRATAS_TLD = { 'coem':'com','comm':'com','cmo':'com','ocm':'com','con':'com','cim':'com',
    'copm':'com','cpm':'com','vom':'com','xom':'com','clm':'com','comn':'com','como':'com','col':'com' };

  function revisar(valor) {
    var v = String(valor || '').trim().toLowerCase();
    if (!v) return { ok: false, texto: 'Escribe tu correo.' };
    if (v.indexOf('..') > -1) return { ok: false, texto: 'Ese correo tiene un punto de más.' };
    if (!RE.test(v)) return { ok: false, texto: 'Ese correo no parece válido. Revísalo, por favor.' };

    var dominio = v.split('@').pop();
    if (DESECHABLES.indexOf(dominio) > -1) {
      return { ok: false, texto: 'Necesitamos un correo permanente: ahí es donde te escribimos.' };
    }
    if (ERRATAS[dominio]) {
      return { ok: false, texto: '¿Quisiste decir @' + ERRATAS[dominio] + '?', sugerencia: v.split('@')[0] + '@' + ERRATAS[dominio] };
    }
    /* Aquí es donde cae un dominio inventado: "gmaidefe.coem" tiene formato
       correcto, pero ".coem" no existe. */
    var tld = dominio.split('.').pop();
    if (tld.length < 2 || /\d/.test(tld)) return { ok: false, texto: 'Revisa la parte final del correo.' };
    if (TLDS.indexOf(tld) === -1) {
      var pista = ERRATAS_TLD[tld] ? ' ¿Quisiste decir .' + ERRATAS_TLD[tld] + '?' : '';
      return { ok: false, texto: 'La terminación ".' + tld + '" no existe.' + pista };
    }

    return { ok: true };
  }

  /* ---- Avisos ------------------------------------------------------------ */

  function aviso(unidad, texto, sugerencia) {
    var msg   = unidad.querySelector('[data-nv-sub-msg]');
    var input = unidad.querySelector('[data-nv-sub-input]');
    if (!msg) return;

    msg.textContent = texto || '';
    msg.hidden = !texto;

    if (sugerencia && input) {
      msg.textContent = texto + ' ';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nv-sub__fixlink';
      b.textContent = 'Corregir';
      b.addEventListener('click', function () { input.value = sugerencia; aviso(unidad, ''); input.focus(); });
      msg.appendChild(b);
    }
  }

  /* ---- Ya suscrito ------------------------------------------------------- */

  function yaSuscrito() {
    try {
      return localStorage.getItem('nv_desc_activo') === '1' ||
             localStorage.getItem('nv_sub_done') === '1';
    } catch (e) { return false; }
  }

  function verHecho(unidad) {
    var vForm = unidad.querySelector('[data-nv-sub-view="form"]');
    var vDone = unidad.querySelector('[data-nv-sub-view="done"]');
    if (vForm) vForm.hidden = true;
    if (vDone) vDone.hidden = false;
  }

  /* ---- Éxito ------------------------------------------------------------- */

  function exito(unidad) {
    verHecho(unidad);

    /* Solo las unidades del descuento marcan al visitante como suscrito. El
       pie de página no: allí uno se apunta a los avisos, no al descuento, y
       si marcara nv_sub_done le cerraría la puerta al descuento sin haberlo
       recibido nunca. */
    if (unidad.hasAttribute('data-nv-sub-descuento')) {
      try { localStorage.setItem('nv_sub_done', '1'); } catch (e) {}
      try { if (typeof window.nvActivarDescuento === 'function') window.nvActivarDescuento(); } catch (e) {}
    }

    try { unidad.dispatchEvent(new CustomEvent('nv-sub:exito', { bubbles: true })); } catch (e) {}
  }

  /* ---- Atar una unidad --------------------------------------------------- */

  function atar(unidad) {
    if (unidad.getAttribute('data-nv-sub-listo') === '1') return;
    unidad.setAttribute('data-nv-sub-listo', '1');

    /* A quien ya está suscrito no se le vuelve a pedir el correo. */
    if (unidad.hasAttribute('data-nv-sub-descuento') && yaSuscrito()) {
      verHecho(unidad);
      return;
    }

    var form  = unidad.querySelector('[data-nv-sub-form]');
    var input = unidad.querySelector('[data-nv-sub-input]');
    if (!form || !input) return;

    /* La tienda tiene la protección anti-bots de Shopify activada: sin su
       token, /contact responde 400 y no se registra a nadie. Esto le pide a
       Shopify que se encargue del formulario. Va envuelto porque es API suya
       y puede no estar. */
    try {
      if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) {
        window.Shopify.captcha.protect(form);
      }
    } catch (e) {}

    input.addEventListener('input', function () { aviso(unidad, ''); });

    form.addEventListener('submit', function (e) {
      var r = revisar(input.value);
      if (!r.ok) {
        e.preventDefault();
        aviso(unidad, r.texto, r.sugerencia);
        input.focus();
        return;
      }
      aviso(unidad, '');

      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Enviando…'; }

      /* Sin preventDefault: el envío es el normal y la página navega. Aquí NO
         se canta victoria: quien dice que el correo quedó registrado es
         Shopify al devolvernos ?customer_posted=true, no nosotros. */
    });
  }

  /* ---- La vuelta de Shopify ---------------------------------------------
     Tras un registro correcto, Shopify devuelve a la misma página con
     ?customer_posted=true y, en el fragmento, el id del formulario que se
     envió (#nv-sub-form-packs, -popup o -footer). Eso dice qué unidad tiene
     que enseñar el "listo" y si toca activar el descuento. -------------- */

  function volvimosDeShopify() {
    var params;
    try { params = new URLSearchParams(location.search); } catch (e) { return; }
    if (params.get('customer_posted') !== 'true') return;

    var id = (location.hash || '').replace('#', '');
    var unidad = null;

    if (id) {
      var form = document.getElementById(id);
      unidad = form ? form.closest('[data-nv-sub-unit]') : null;
    }
    /* Sin fragmento no se sabe cuál fue: se elige la que no da descuento,
       para no regalar nada que no se haya pedido. */
    if (!unidad) {
      unidad = document.querySelector('[data-nv-sub-unit]:not([data-nv-sub-descuento])');
    }
    if (unidad) exito(unidad);

    /* Se limpia la URL para que un refresco no lo repita. */
    try {
      var limpia = location.pathname + location.search.replace(/[?&]customer_posted=true/, '').replace(/^&/, '?');
      window.history.replaceState({}, '', limpia);
    } catch (e) {}
  }

  function arrancar() {
    document.querySelectorAll('[data-nv-sub-unit]').forEach(atar);
    volvimosDeShopify();
  }

  /* Se expone por si alguna sección pinta una unidad más tarde. */
  window.nvSuscripcion = { atar: arrancar, revisar: revisar, yaSuscrito: yaSuscrito };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  } else {
    arrancar();
  }
})();
